import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/** One grouped read of cached card data; calendars only when asked (they are large). */
export const getTourCards = createServerFn({ method: "POST" })
  .inputValidator(z.object({ ids: z.array(z.string().regex(/^\d{1,12}$/)).max(200), calendar: z.boolean().optional() }))
  .handler(async ({ data }) => {
    const { readTourCards } = await import("./tour-card-cache.server");
    return readTourCards(data.ids, { calendar: data.calendar });
  });

/** Quote a public tour that has no cached card yet; existing rows are left to the cron. */
export const fillTourCard = createServerFn({ method: "POST" })
  .inputValidator(z.object({ id: z.string().regex(/^\d{1,12}$/) }))
  .handler(async ({ data }) => {
    const { fillMissingTourCard } = await import("./tour-card-cache.server");
    try { return { price: await fillMissingTourCard(data.id) }; } catch { return { price: null }; }
  });
